export default __webpack_public_path__ + "static/media/Vambraces of the Tireless Defender.db2d166f.jpg";